<template>
  <div>    
    <all-insurances displayRemoveOption :insurances="insurances.future" />
    <all-insurances displayRemoveOption :insurances="insurances.present" />
    <div v-if="showOwnInsuranceMessage">
      <span>Tenant provided their own insurance</span>
      <div v-if="declinedInsurance.expirationMonth || declinedInsurance.expirationYear" class="hb-text-night-light hb-font-caption">
        Coverage expires on 
        <span v-if="declinedInsurance.expirationMonth">
          {{ declinedInsurance.expirationMonth - 1 | convertMonthNumberToName }}
        </span>
        <span v-if="declinedInsurance.expirationYear">
          {{ declinedInsurance.expirationYear }}
        </span>
      </div>
    </div>

    <div class="hb-text-light hb-font-caption pt-2 pb-2">
      <hb-tooltip>
        <template slot="item">
          <span style="border-bottom: thin dashed; cursor: pointer">
            Past Insurances ({{ insurances.past && insurances.past.length }})
          </span>
        </template>
        <template slot="body">
          <all-insurances
            :insurances="insurances.past"
            durationPeriodColor="#fff"
            displayNoInsuranceMessage
          />
        </template>
      </hb-tooltip>
    </div>

    <add-new-insurance 
      v-if="showAddInsuranceModal" 
      v-model="showAddInsuranceModal"
      :declinedInsurance="declinedInsurance"
      :currentInsurance="insurances.present && insurances.present[insurances.present.length - 1]" 
      :futureInsurance="insurances.future && insurances.future[insurances.future.length - 1]"
      :contact="contact" 
      :lease="lease" 
      @close="closeAddInsuranceModal" />
      <hb-tooltip v-if="isFreeCoverageRestricted">
      <template v-slot:item>
        <hb-link>
            Change Coverage
          </hb-link>
      </template>
      <template v-slot:body>
        Insurance can be modified after free coverage period ends on {{ formattedCoverageEndDate }}.
      </template>
    </hb-tooltip>

    <hb-link @click="addInsurance" v-if="!isFreeCoverageRestricted && !(is_closed || isAuctioned) && getConfigurationStatus(lease.Unit.unit_type_id, 'have_coverage')">Change Coverage</hb-link>
  </div>
</template>

<script type="text/babel">
import api from "../../../assets/api.js";
import AllInsurances from "./AllInsurances.vue";
import AddNewInsurance from "./AddNewInsurance.vue";
import moment from 'moment';
import { EventBus } from '../../../EventBus';
import { mapActions } from 'vuex';

export default {
  name: "InsurancesInfo",
  data() {
    return {
      insurances: {
        past: [],
        present: [],
        future: [],
      },
      declinedInsurance: null,
      showAddInsuranceModal: false,
      freeCoverageEndDate: null
    };
  },

  props: {
    lease: {
      type: Object,
      required: true,
    },
    contact: {
      type: Object,
      required: true
    },
    unit: {
      type: Object,
      required: false
    }
  },

  components: {
    AllInsurances,
		AddNewInsurance
  },

  async created() {
  	EventBus.$on('closeAddInsuranceModal', this.closeAddInsuranceModal);
  	EventBus.$on('fetchInsurances', this.fetchInsurances);

    await this.fetchInsuranceSettings();
    await this.fetchInsurances();
    await this.fetchFreeCoverageDetails();
  },

  destroyed() {
    EventBus.$off('closeAddInsuranceModal', this.closeAddInsuranceModal);
  	EventBus.$off('fetchInsurances', this.fetchInsurances);
  },
  computed: {
    is_closed(){
      return moment(this.lease.end_date).startOf('day') <= moment().startOf('day');
    },
    isAuctioned(){
      return ( ['auction_payment','move_out'].includes(this.lease.auction_status))
    },
    isFreeCoverageRestricted() {
      if (!this.freeCoverageEndDate) return false;
      return moment().isBefore(moment(this.freeCoverageEndDate).startOf("day"));
    },
    formattedCoverageEndDate() {
      return this.freeCoverageEndDate ? moment(this.freeCoverageEndDate).format("MMMM DD, YYYY") : "";
    },
    showOwnInsuranceMessage() {
      const noPresent = !this.insurances.present.length;
      const noFuture = !this.insurances.future.length;
      const latestFutureInsurance = this.insurances.future[this.insurances.future.length - 1];
      const hasRemovedFutureInsurance = latestFutureInsurance && latestFutureInsurance.start_date &&
      latestFutureInsurance.end_date && new Date(latestFutureInsurance.start_date) > new Date(latestFutureInsurance.end_date);

      return (
        (noPresent && noFuture && this.declinedInsurance && this.declinedInsurance.status === 1) ||
        (noPresent && this.insurances.future.length > 0 && hasRemovedFutureInsurance)
      );
    }
  },
  methods: {
    ...mapActions({
      fetchInsuranceSettings: "settingsStore/fetchInsuranceSettings",
    }),
    closeAddInsuranceModal() {
      this.showAddInsuranceModal = false;
    },
    addInsurance() {
      this.showAddInsuranceModal = true;
    },
    async fetchInsurances() {
      try {
        let res = await api.get(
          this,
          `${api.LEASES}/${this.lease.id}/all-insurances`
        );

        let { insurances, declinedInsurance } = res;
        this.insurances = insurances;
        this.declinedInsurance = declinedInsurance
      } catch(err) {
        console.log('err ', err);
      }
    },
    async fetchFreeCoverageDetails(){
      try {
        this.freeCoverageEndDate = null;
        let res = await api.get(this, `${api.LEASES}/${this.lease.id}/insurance`);
        if (res.data && 'free_coverage_end_date' in res.data) {
          this.freeCoverageEndDate = res.data.free_coverage_end_date;
        } else {
          this.freeCoverageEndDate = null;
        }
      }catch(err){
        console.log('err ', err);
      }
    }
  },
};
</script>

<style>
.disabled-link {
  pointer-events: none;
  opacity: 0.5; 
  cursor: not-allowed;
}
</style>